import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/thank-you',
    name: 'Thank You',
    component: () => import('../views/ThankYou.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
  },
  // LETS BUY
  {
    path: '/properties/for-sale',
    name: 'Properties For Sale',
    component: () => import('../views/PropertiesForSale.vue'),
  },
  {
    path: '/office/properties/for-sale/:id',
    name: 'Properties For Sale',
    meta: {
      hide: true,
    },
    component: () => import('../views/OfficePropertiesForSale.vue'),
  },
  {
    path: '/open-homes',
    name: 'Open Homes',
    component: () => import('../views/InspectionTimes.vue'),
  },
  {
    path: '/tips-and-tricks-buy',
    name: 'Tips and Tricks',
    component: () => import('../views/TipsAndTricksBuy.vue'),
  },
  // LETS SELL
  {
    path: '/properties/sold',
    name: 'Sold Properties',
    component: () => import('../views/PropertiesSold.vue'),
  },
  {
    path: '/office/properties/sold/:id',
    name: 'Sold Properties',
    meta: {
      hide: true,
    },
    component: () => import('../views/OfficePropertiesSold.vue'),
  },
  {
    path: '/forms/sales-appraisal',
    name: 'Sales Appraisal',
    component: () => import('../views/SalesAppraisal.vue'),
  },
  {
    path: '/tips-and-tricks-sell',
    name: 'Tips and Tricks',
    component: () => import('../views/TipsAndTricksSell.vue'),
  },
  // LETS RENT
  {
    path: '/properties/for-rent',
    name: 'Properties For Rent',
    component: () => import('../views/PropertiesForRent.vue'),
  },
  {
    path: '/office/properties/for-rent/:id',
    name: 'Properties For Rent',
    meta: {
      hide: true,
    },
    component: () => import('../views/OfficePropertiesForRent.vue'),
  },
  {
    path: '/forms/lease-appraisal',
    name: 'Lease Appraisal',
    component: () => import('../views/LeaseAppraisal.vue'),
  },
  {
    path: '/forms/repair-request',
    name: 'Repair Request',
    component: () => import('../views/RepairRequest.vue'),
  },
  {
    path: '/tips-and-tricks-rent',
    name: 'Tips and Tricks',
    component: () => import('../views/TipsAndTricksRent.vue'),
  },
  // OUR AGENTS
  {
    path: '/our-agents',
    name: 'Our Agents',
    component: () => import('../views/OurAgents.vue'),
  },
  {
    path: '/office/our-agents/:id',
    name: 'Our Agents',
    meta: {
      hide: true,
    },
    component: () => import('../views/OfficeOurAgents.vue'),
  },
  // SIDE MENU
  {
    path: '/contact-us',
    name: 'Contact Us',
    component: () => import('../views/ContactUs.vue'),
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/Blog.vue'),
  },
  // OTHER
  {
    path: '/forms/notice-of-intention-to-leave',
    name: 'Notice of Intention to Leave',
    component: () => import('../views/Form13.vue'),
  },
  {
    path: '/tv-display/sales',
    name: 'TV Display Sales',
    component: () => import('../views/TVDisplaySales.vue'),
    meta: {
      hide: true,
      hideAncillaries: true, // Disables the header and footer
    },
  },
  {
    path: '/tv-display/rentals',
    name: 'TV Display Rentals',
    component: () => import('../views/TVDisplayRentals.vue'),
    meta: {
      hide: true,
      hideAncillaries: true, // Disables the header and footer
    },
  },
  {
    path: '/listings/:id',
    name: 'Listing',
    meta: {
      hide: true,
    },
    component: () => import('../views/ListingDetails.vue'),
  },
  {
    path: '/listings/:id/make-an-offer',
    name: 'Make an Offer',
    meta: {
      hide: true,
    },
    component: () => import('../views/ListingMakeAnOffer.vue'),
  },
  {
    path: '/offices/:id',
    name: 'Office',
    meta: {
      hide: true,
    },
    component: () => import('../views/OfficeDetails.vue'),
  },
  {
    path: '/profiles/:id',
    name: 'Profile',
    meta: {
      hide: true,
    },
    component: () => import('../views/AgentProfile.vue'),
  },
  {
    path: '/profiles/:id/appraisal',
    name: 'Profile Appraisal',
    meta: { hide: true },
    component: () => import('../views/AgentProfileAppraisal.vue'),
  },
  {
    path: '/blogs/:id',
    name: 'Blog',
    meta: {
      hide: true,
    },
    component: () => import('../views/BlogDetails.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('../views/PrivacyPolicy.vue'),
  },
  {
    path: '/sitemap',
    name: 'Sitemap',
    component: () => import('../views/Sitemap.vue'),
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: () => import('../views/Unsubscribe.vue'),
  },
  {
    path: '/*',
    name: 'Not Found',
    meta: {
      hide: true,
    },
    component: () => import('../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
});

export default router;
